import { StyledLightningLinkCasino, StyledRibbonWithImage } from './style';
import { BundleProps } from 'utils/types';
import { Box } from '@mui/system';
import { LightningLinkCasinoBundlePrice } from './BundlePrice';
import { EBadgeType, EGradientDirection, EProductPriority } from 'utils/enums';
import { useEffect, useState } from 'react';
import { LightningLinkMainProduct } from './Products/MainProduct';
import { LightningLinkSubProduct } from './Products/SubProduct';
import { LightningLinkSaleBadge } from 'components/Badge/Sale/LightningLinkSaleBadge';
import { IExtendedTooltipProps } from 'components/TooltipTemplate/types';
import { BadgeData, IEmblemBadge, IRibbonBadge } from 'components/Badge/types';
import { useGetBadge } from 'utils/useGetBadge';

export const LightningLinkBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#406cf9',
    colorTwo: '#6449ff',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  badges = [],
  emblemBadges = [],
  ribbonBadges = [],
  bundleButtonColor,
  bundleButtonTextColor,
  salePercentage = 0,
  fontFamily,
  salePercentageDisplayType,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
}) => {
  const emblemBadgeNew = useGetBadge<IEmblemBadge>(emblemBadges);
  const [emblemBadgeOld, setEmblemBadgeOld] = useState<any>(null);
  const [ribbonBadgeOld, setRibbonBadgeOld] = useState<any>(null);
  const ribbonBadgeNew = useGetBadge<IRibbonBadge>(ribbonBadges);
  useState<IExtendedTooltipProps | null>(null);
  const [mainProduct, setMainProduct] = useState<any>(null);
  const [subProduct, setSubProduct] = useState<any>(null);
  const [isMainFirst, setIsMainFirst] = useState<boolean>(true);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadgeOld(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadgeOld(null);
    }
  }, [badges]);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundRibbon = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.RIBBON || b.type === EBadgeType.RIBBON
        );
      });
      setRibbonBadgeOld(foundRibbon?.badge?.ribbon || foundRibbon?.ribbon);
    } else {
      setRibbonBadgeOld(null);
    }
  }, [badges]);

  const emblemBadge = emblemBadgeNew ?? emblemBadgeOld;
  const ribbonBadge = ribbonBadgeNew ?? ribbonBadgeOld;

  useEffect(() => {
    let main = productList.find(
      (product) => product.priority === EProductPriority.MAIN,
    );
    const sub = productList.find(
      (product) => product.priority === EProductPriority.SUB,
    );

    if (main && sub && productList[0].priority === EProductPriority.SUB) {
      setIsMainFirst(false);

      // ACDEV-8957: Undo this PR this logic after we can have stroked for second product
      if (sub.strokedSaleQuantity) {
        main = { ...main, strokedSaleQuantity: sub.strokedSaleQuantity };
      }
    }

    setMainProduct(main);
    setSubProduct(sub);
  }, [productList, tooltipLoadCallback]);

  return (
    <StyledLightningLinkCasino
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      fontFamily={fontFamily}
      className="lightning-link-bundle"
    >
      {emblemBadge && (
        <div className="lightning-link-bundle__emblem-badge">
          <img alt={'emblem-badge'} src={emblemBadge.imageUrl} />
        </div>
      )}
      {salePercentage > 0 && (
        <LightningLinkSaleBadge
          salePercentage={salePercentage}
          salePercentageDisplayType={salePercentageDisplayType}
        />
      )}
      {ribbonBadge?.imageUrl && (
        <StyledRibbonWithImage
          color={ribbonBadge.textColor}
          title={ribbonBadge?.text}
        >
          <img alt={'ribbon-badge'} src={ribbonBadge.imageUrl} />
          <div className={'ribbon-title'}>{ribbonBadge?.text}</div>
        </StyledRibbonWithImage>
      )}
      {isMainFirst ? (
        <Box className={'lightning-link-bundle__products-container'}>
          {mainProduct && (
            <LightningLinkMainProduct
              mainProduct={mainProduct}
              salePercentage={salePercentage}
            />
          )}
          {subProduct && (
            <LightningLinkSubProduct
              subProduct={subProduct}
              tooltipLoadCallback={tooltipLoadCallback}
              tooltipOpenEventHandler={tooltipOpenEventHandler}
            />
          )}
        </Box>
      ) : (
        <Box className={'lightning-link-bundle__products-container'}>
          {subProduct && (
            <LightningLinkSubProduct
              subProduct={subProduct}
              tooltipLoadCallback={tooltipLoadCallback}
              tooltipOpenEventHandler={tooltipOpenEventHandler}
            />
          )}
          {mainProduct && (
            <LightningLinkMainProduct
              mainProduct={mainProduct}
              salePercentage={salePercentage}
            />
          )}
        </Box>
      )}
      <LightningLinkCasinoBundlePrice
        prices={prices}
        bundleButtonColor={bundleButtonColor}
        bundleButtonTextColor={bundleButtonTextColor}
        fontFamily={fontFamily}
      />
    </StyledLightningLinkCasino>
  );
};
